import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { AppLocation } from '../../../core/models/interface/geo';
import {
  MapBoundsAndZoom,
  CustomMapActionConfig,
  BuyflowMapInitialization,
} from '../../shared/app-buyflow-map/app-buyflow-map.component';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ContainsSubscriptions } from '../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../core/pure-functions/rx-helper';

@Component({
  selector: 'app-buyflow-map-dialog',
  templateUrl: './buyflow-map-dialog.component.html',
  styleUrls: ['./buyflow-map-dialog.component.scss'],
})
export class BuyflowMapDialogComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  vessels: Vessel[];
  location: AppLocation;
  customActionConfig: CustomMapActionConfig;
  updateMapBounds: BehaviorSubject<MapBoundsAndZoom>;
  boundedAndFilteredResult: BehaviorSubject<{ vessels: Vessel[] }>;
  updateVesselSubject: BehaviorSubject<{
    vessels: Vessel[];
  }> = new BehaviorSubject(null);
  buyflowMapInitialization: BuyflowMapInitialization;

  subs: Subscription[] = [];

  constructor(
    public dialogRef: MatDialogRef<BuyflowMapDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.vessels = data.vessels;
    this.location = data.location;
    this.updateMapBounds = data.updateMapBounds;
    this.boundedAndFilteredResult = data.boundedAndFilteredResult;
    this.buyflowMapInitialization = data.buyflowMapInitialization;
    this.customActionConfig = {
      icon: 'fa fa-times fa-3x',
      position: 7,
    };
  }

  ngOnInit() {
    this.initWatchers();
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  onActionClick(): void {
    this.dismiss();
  }

  dismiss(): void {
    this.dialogRef.close();
  }

  onUpdateBoundsEvent(bounds: MapBoundsAndZoom) {
    this.updateMapBounds.next(bounds);
  }

  private initWatchers(): void {
    const sub = this.boundedAndFilteredResult.subscribe((theVessels) => {
      this.updateVesselSubject.next(theVessels);
    });
    this.subs.push(sub);
  }
}
